/**
 * 本地进度镜像
 *
 * 云端是权威，但弱网/离线时也要能玩、能看进度。
 * 因此每次结算后本地也记一份（只保留更好成绩），联网时与云端合并展示。
 */

import { readJson, writeJson, type KeyValueStore } from "./storage.js";
import type { LevelProgress } from "../api/client.js";

const STORAGE_KEY = "chuandeng.progress.local.v1";

export class LocalProgressStore {
  constructor(private readonly store: KeyValueStore) {}

  list(): LevelProgress[] {
    return readJson<LevelProgress[]>(this.store, STORAGE_KEY, []);
  }

  get(levelId: string): LevelProgress | undefined {
    return this.list().find((row) => row.levelId === levelId);
  }

  record(chapterId: string, levelId: string, score: number, stars: number): void {
    const rows = this.list();
    const existing = rows.find((row) => row.levelId === levelId);
    if (existing) {
      existing.bestScore = Math.max(existing.bestScore, score);
      existing.stars = Math.max(existing.stars, stars);
      existing.chapterId = chapterId;
    } else {
      rows.push({ chapterId, levelId, bestScore: score, stars });
    }
    writeJson(this.store, STORAGE_KEY, rows);
  }

  /** 云端进度与本地进度合并（取更好的），用于关卡选择界面 */
  static merge(cloud: readonly LevelProgress[], local: readonly LevelProgress[]): LevelProgress[] {
    const merged = new Map<string, LevelProgress>();
    for (const row of [...cloud, ...local]) {
      const existing = merged.get(row.levelId);
      if (!existing) {
        merged.set(row.levelId, { ...row });
        continue;
      }
      existing.bestScore = Math.max(existing.bestScore, row.bestScore);
      existing.stars = Math.max(existing.stars, row.stars);
    }
    return [...merged.values()];
  }
}
